module.exports = __webpack_public_path__ + "img/Wechselladerfahrzeug.1bcb06dd.svg";